// extracted by mini-css-extract-plugin
module.exports = {"tag":"Tag_tag__Yr0s3","md":"Tag_md__l5QtN","sm":"Tag_sm__s7njr"};